import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import i18n from 'i18n-react';
import { buttonBar } from 'settings';
import ButtonSet from 'components/ButtonSet';
import SweetAlert from 'components/SweetAlert';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { isRewardsCountry } from 'helpers/isRewardsCountry';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';
import clsx from 'clsx';

const BarAnim = posed.div({
  enter: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 50,
  },
});

const ButtonBar = (props) => {
  const { className } = props;
  const { buttonsTravPro, buttonsAmbassador, orientation } = buttonBar;

  const [buttons, setButtons] = useState([]);
  const [flags, setFlags] = useState({});
  const [isRewardsCountryEligible, setIsRewardsCountryEligible] = useState(false);
  const [userStatus, setUserStatus] = useState('startTraining');
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    const setButtonConfig = async () => {
      const nextFlags = await getFeatureFlags();
      setFlags(nextFlags);

      const user = await StorageHandler.load(storageKeys.user);
      const userCountry = user?.country ?? '';
      setIsRewardsCountryEligible(await isRewardsCountry(userCountry));
      if (user?.training_graduated) {
        setUserStatus('graduated');
      } else if (user?.training_started) {
        setUserStatus('continueTraining');
      } else {
        setUserStatus('startTraining');
      }

      const selectedButtonGroup = nextFlags.ambassador ? buttonsAmbassador : buttonsTravPro;
      const filteredButtons = selectedButtonGroup.filter((btn) => {
        if (btn.id === 'directory') {
          return nextFlags.button_bar_directory;
        }
        if (btn.id === 'retain') {
          return !nextFlags.no_retain;
        }
        return true;
      });
      setButtons(filteredButtons);
    };
    setButtonConfig();
  }, [buttonsAmbassador, buttonsTravPro]);

  const rewardsLocked =
    isRewardsCountryEligible && flags.rewards_graduation_required === true && userStatus !== 'graduated';
  const handleRewardsClick = (e) => {
    if (rewardsLocked) {
      e.preventDefault();
      setPopup(true);
    }
  };
  const smartAssistEnabled = flags.smart_assist === true;

  return (
    <BarAnim data-testid="buttonBar" key="BarAnim" className={clsx('buttonBar', className)}>
      {smartAssistEnabled ? (
        <ButtonSet
          orientation={orientation}
          variant="smartAssistHome"
          showRewards={flags.rewards && isRewardsCountryEligible}
          rewardsLocked={rewardsLocked}
          onRewardsClick={handleRewardsClick}
        />
      ) : (
        buttons && <ButtonSet buttons={buttons} orientation={orientation} />
      )}
      <SweetAlert
        title=""
        trigger={popup}
        html={i18n.translate('rewards.lockedPopupNotGraduated')}
        confirmButtonText={i18n.translate('general.close')}
        onClose={() => setPopup(false)}
      />
    </BarAnim>
  );
};

export default ButtonBar;

ButtonBar.propTypes = {
  className: PropTypes.string,
};

ButtonBar.defaultProps = {
  className: null,
};
